<div class="sticky-at-top new-filter-sidebar" #stickyMenu [class.sticky]="sticky">
    <div class="modal fade filter-modal" bsModal #staticModal="bs-modal" tabindex="-1" role="dialog"
        aria-labelledby="dialog-static-name">
        <div class="modal-content p-3">

            <div class="filter-wrapper">
                <!-- <a class="close-icon d-block d-lg-none cursor" title="close" (click)="bsModalService.hide()">
                    <img src="../../assets/images/close-icon.svg" alt="close-icon" />
                </a> -->
                <div [ngClass]="{'active-filter': filterSelected > 0? true: false, 'filter-header': true}">
                    <h2>Filter by <span *ngIf="filterSelected > 0">({{filterSelected}})</span></h2>
                    <button class="remove-all" (click)="onRemoveAllHandler()" href="javascript:void(0)"
                        title="Remove All">
                        Clear All
                    </button>
                </div>
                <div>
                    <div class="toggle-button">
                        <p>Order Again</p>
                        <label class="switch">
                            <input type="checkbox" [checked]="range == '1' ? true : false" [value]="range"
                                (change)="selectRange($event)">
                            <span class="slider round"></span>
                        </label>
                    </div>
                    <div class="divider mb-0"></div>
                    <div class="accordion-filter common-accordion all-product-filters">
                        <accordion [isAnimated]="true">
                            <accordion-group heading="PMP Products" [isOpen]="true">
                                <ul class="custom-checkbox">
                                    <li *ngFor="let product of pmpProduct; let i = index">
                                        <input class="styled-radio" id="radio{{product.id}}" type="radio"
                                            [value]="filterSelectedValues.selectedPmpProductValue"
                                            (change)="onSelectPmp(product.id)"
                                            [checked]="filterSelectedValues.selectedPmpProductValue == product.id">
                                        <label for="radio{{product.id}}">{{product.name}}</label>
                                    </li>
                                </ul>
                            </accordion-group>
                            <accordion-group heading="Promotions" [isOpen]="true" *ngIf="promotionFilter.length != 0">
                                <ul class="custom-checkbox">
                                    <li *ngFor="let promotion of promotionFilter; let i = index">
                                        <input class="styled-radio" id="radio{{promotion.id}}" type="radio"
                                            value="value{{promotion.id}}"
                                            (change)="onSelectPromotion(promotion.id,promotion.name)"
                                            [checked]="filterSelectedValues.promotionSelected == promotion.id">
                                        <label for="radio{{promotion.id}}">{{promotion.name}}</label>
                                    </li>
                                </ul>
                            </accordion-group>
                            <accordion-group heading="Brands" [isOpen]="true" *ngIf="brandFilter.length != 0">
                                <div class="search-box">
                                    <img class="search" src="../../assets/images/search.svg" alt="">
                                    <input type="text" placeholder="Search for Brands"
                                        (keyup)="getKeyUpEnterValue($event)" [(ngModel)]="searchBrandText" />
                                    <img class="clear" src="../../assets/images/close-search.svg" alt=""
                                        *ngIf="searchBrandText != ''" (click)="onsearchClear()">
                                </div>
                                <ul class="custom-checkbox">
                                    <li
                                        *ngFor="let brand of brandFilter | searchBrands:searchBrandText  | slice:0:10 ; let i = index">
                                        <input class="styled-radio" id="radio{{brand.id}}" type="radio"
                                            value="value{{brand.id}}" (change)="onSelectBrand(brand.id)"
                                            [checked]="filterSelectedValues.brandSelected == brand.id">
                                        <label for="radio{{brand.id}}">{{brand.label}}</label>
                                    </li>
                                </ul>
                                <span class="more-brands" (click)="openBrandsModal()">
                                    {{brandFilter.length > 10 ? ('+'+(brandFilter.length-10)+' More') :
                                    ''}}
                                </span>
                            </accordion-group>

                        </accordion>

                    </div>
                    <!-- Range sliders -->
                    <div class="range-silder">
                        <span>RSP</span>

                        <ngx-slider [(value)]="filterSelectedValues.rspMinValue"
                            [(highValue)]="filterSelectedValues.rspMaxValue" [options]="options"
                            (userChangeEnd)='rspFilter(filterSelectedValues.rspMaxValue, filterSelectedValues.rspMinValue)'></ngx-slider>
                        <ul class="cost-range">
                            <li>£{{filterSelectedValues.rspMinValue}}</li>
                            <li>£{{filterSelectedValues.rspMaxValue}}+</li>
                        </ul>
                    </div>

                </div>
            </div>
        </div>
    </div>
</div>